import {useCallback, useState} from 'react';

import {Subscriptions} from '~/modules/api';
import {useUpdateDiscountCodeMutation} from '~/store/rtkQuery';

export const EditDiscountCodeModal = ({
  code,
  onComplete,
  onCancel,
}: {
  code: Subscriptions.DiscountCode;
  onComplete: () => void;
  onCancel: () => void;
}) => {
  const [updateDiscountCode, {error}] = useUpdateDiscountCodeMutation();

  const [active, setActive] = useState(code.active);

  const onUpdateCode = useCallback(async () => {
    const update: Subscriptions.UpdateDiscountCodeRequest = {
      id: code.id,
      code: code.code,
      active: active,
    };
    const response = await updateDiscountCode(update);

    if (!('error' in response)) {
      onComplete();
    }
  }, [code, active, updateDiscountCode, onComplete]);

  return (
    <dialog className="modal modal-open">
      <div className="modal-box">
        <div className="text-2xl">{code.code}</div>

        <div className="py-4">
          <div className="form-control py-4">
            <label className="label">
              <span className="label-text">Code Active</span>
              <input
                type="checkbox"
                checked={active}
                className="checkbox checkbox-primary"
                onChange={e => setActive(e.target.checked)}
              />
            </label>
          </div>
        </div>

        {!!error && (
          <div role="alert" className="alert alert-error">
            <span>{error.message}</span>
          </div>
        )}

        <div className="modal-action">
          <button className="btn" onClick={onCancel}>
            Close
          </button>
          <button className="btn btn-primary" onClick={onUpdateCode}>
            Save
          </button>
        </div>
      </div>
    </dialog>
  );
};
